import { render, staticRenderFns } from "./VentanaOperacionesInspeccion.vue?vue&type=template&id=0135f0b0"
import script from "./VentanaOperacionesInspeccion.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesInspeccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports